
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Subline extends Vue {
  @Prop({ default: 'span' }) element!: string;
  @Prop({ required: true }) text!: string;
  @Prop({ default: false }) isDark!: boolean;

  get classNames() {
    return [
      { 'subline--dark': this.isDark },
    ];
  }
}
